import { Row } from '@helvetia/components/layout/Row'
import { styled } from '@helvetia/components/theme'
import { breakpoints } from '@helvetia/components/theme/breakpoints'
import {
  VerticalMarginProps,
  verticalMarginsCss,
} from '@helvetia/components/theme/css'

export const PageWrapper = styled.div`
  max-width: ${breakpoints.desktop}px;
  position: relative;
  display: flex;
  flex-direction: column;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`

export const TextBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const EditIconWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`
export const BoxWrapper = styled(Row)`
  flex-direction: column;
  flex-wrap: wrap;
  flex-basis: 0;
  justify-items: space-between;
  justify-content: flex-end;
  align-items: space-between;
  align-content: flex-end;
`
export const ItemWrapper = styled.div.attrs({})<VerticalMarginProps>`
  ${verticalMarginsCss}
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: flex-start;
  justify-content: space-between;
`
